<template>
  <div class="home">
    <header>
      <Header v-if="getUser"/>
      
      <div v-else class="container-fluid">
        <div class="row row2">
          <div>
            <img v-if="getPartner" class="bkps-logo-dashboard" :src="getPartner.logo_url"/>
            <img v-else class="bkps-logo-dashboard" src="@/assets/images/logo-brobot-azul@250x50.png"/>
         </div>
        </div>
      </div>
    </header>
    
    <main>
      <div class="container">
        
        <h3 class="bold mb-4 mt-5">
          Brobot Platform - Status de serviços
        </h3>
      
        <TabContainer>
          <Tabs name="Órgãos Autuadores" start-active>
            <ScrapingServiceTable />
          </Tabs>
          <Tabs v-if="getUser" name="Prefeituras">
    
            <div class="row mt-4 mb-4">
              <div class="col-md-8">
                <input v-model="nextGeneric" type="search" class="input form-control"
                       placeholder="Pesquisar por prefeitura, código IBGE ou UF">
              </div>
              
              <div class="col-md-1">
                <button v-show="generic && nextGeneric" class="btn btn-link nowrap" @click="clearFilter()">
                  Limpar filtro
                </button>
              </div>
              
              <div class="col-md-3">
                <button class="btn btn-outline btn-xl float-right" @click="downloadCSV">
                  Exportar
                </button>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6 mt-2">
                <strong>{{ infoTotalModels }}</strong>
              </div>
            </div>
            
            <table class="table table-borderless table-border table-align table-h51">
              <thead>
                <tr>
                  <th>UF</th>
                  <th>Cidade</th>
                  <th>Código IBGE</th>
                  <th class="text-center">Certificado</th>
                  <th class="text-center">CNPJ do Prestador</th>
                  <th class="text-center">IM do Prestador</th>
                  <th class="text-center">Login/Senha</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="([uf, city, city_code, certificate, provider_cnpj, provider_im, login], index) in showLines" :key="index">
                  <td>{{ uf }}</td>
                  <td>{{ city }}</td>
                  <td>{{ city_code }}</td>
                  <td class="text-center">
                    <div class="status-cycle" :class="`status-cycle-${certificate}`"/>
                  </td>
                  <td class="text-center">
                    <div class="status-cycle" :class="`status-cycle-${provider_cnpj}`"/>
                  </td>
                  <td class="text-center">
                    <div class="status-cycle" :class="`status-cycle-${provider_im}`"/>
                  </td>
                  <td class="text-center">
                    <div class="status-cycle" :class="`status-cycle-${login}`"/>
                  </td>
                </tr>
              </tbody>
            </table>
    
            <div class="row">
              <div class="col-md-12 my-1">
                <Pagination
                  v-model="page"
                  :total-count="showLines.length"
                  :total-pages="totalPages"
                  @pagination="pagination"
                />
              </div>
            </div>
    
          </Tabs>
        </TabContainer>
        
      </div>
      
    </main>
  </div>
</template>

<script>
  import Header from '@/components/dashboard/Header.vue';
  import GetUser from '@/mixins/GetUser.vue'
  import GetPartner from '@/mixins/GetPartner'

  import TabContainer from './shares/TabContainer.vue'
  import Pagination from '@/components/shares/specialTag/Pagination.vue'
  import Tabs from './shares/Tab.vue'
  import ScrapingServiceTable from '@/components/Status/ScrapingServiceTable.vue';

  export default {
    components: {ScrapingServiceTable, Header, Pagination, TabContainer, Tabs },
    computed: {
      infoTotalModels() {
        const total = this.selectedLines.length
        if (total === 0)
          return 'Nenhum registro'
    
        let page = this.page
        let perPage = 10
        let startPage = perPage * (page -1) + 1
        let lastPage = Math.min(perPage * page, total)
        return `Mostrando de ${startPage} até ${lastPage} de ${total} registro(s)`
      },
      selectedLines() {
        return this.lines.filter(line => line.toString()
                    .toLowerCase()
                    .includes(this.generic.toLowerCase()))
      },
      showLines() {
        const start = (this.page - 1) * this.perPage
        return this.selectedLines.slice(start, start + this.perPage)
      },
      totalPages() {
        return Math.ceil(this.selectedLines.length / this.perPage)
      },
    },
    created() {
      let tab = this.$route.query.tab
      if (tab) this.tab = tab.toLowerCase()
      
      this.checkChangeGeneric()
      
      if (this.getUser)
        this.getCustomTable()
    },
    data() {
      return {
        generic: '',
        headers: [
          { id: null, name: 'uf' },
          { id: null, name: 'city' },
          { id: null, name: 'code_city' },
          { id: null, name: 'certificate?' },
          { id: null, name: 'provider_cnpj?' },
          { id: null, name: 'provider_im?' },
          { id: null, name: 'login?' },
          { id: null, name: 'enabled' },
        ],
        lines: [],
        nextGeneric: '',
        page: 1,
        perPage: 10,
        tab: '',
      }
    },
    methods: {
      checkChangeGeneric() {
        this.setIntervalCheckChangeGeneric = setInterval(() => {
          if (this.generic !== this.nextGeneric) {
            this.generic = this.nextGeneric
            this.page = 1
          }
        }, 2500)
      },
      clearFilter() {
        this.generic = ''
        this.nextGeneric = ''
      },
      downloadCSV() {
        const lines = this.selectedLines.map(line => line.join(';').replace(/true/g, 'Sim').replace(/false/g, 'Não'))
        lines.unshift('UF;Cidade;Código IBGE; CNPJ do Prestador; IM do Prestador; Login/Senha')
        const blob = new Blob([lines.join('\n')])
        this.$parse.buildDownload('prefeituras.csv', blob)
      },
      getCustomTable() {
        const key = 'nfse_code_city_table'
        let customTable = this.$ls.get(key, { withoutKey: true })
        if (customTable) {
          this.setData(customTable)
          return
        }
        
        this.axios.get('custom_tables/nfse_code_city_table')
          .then(response => response.data)
          .then(customTable => {
            this.setData(customTable)
            this.$ls.set(key, customTable, { minutes: 24 * 60, withoutKey: true })
          })
      },
      pagination(page) {
        this.page = page
      },
      setData(customTable) {
        customTable.columns.forEach(column => {
          const name = column.name
          const header = this.headers.find(h => h.name === name)
          if (header)
            header.id = column.id
        })
        
        customTable.rows.forEach(row => {
          const line = []
          this.headers.forEach(header => {
            const obj = row.find(e => e.ci == header.id)
            if (obj)
              line.push(obj.v)
          })
          if (line[line.length -1] === 'true')
            this.lines.push(line)
        })
      }
    },
    mixins: [GetUser, GetPartner],
    name: 'Status'
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/_main.scss";
  
  main {
    overflow-y: auto;
    padding: 0;
    grid-area: grid-main;
  }
  
  .home {
    display: grid;
    height: 100vh;
    grid-template-columns: 100%;
    grid-template-rows: 91px 1fr;
    grid-template-areas:
        'grid-header'
        'grid-main';
  }

  .btn-status {
    background: #15CE9A;
    border-style: none;
    color: white;
    border-radius: 5px;
    display: inline-block;
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  
  .status-cycle {
    height: 24px;
    width: 24px;
    border-radius: 12px;
    display: inline-block;
  }
  
  .status-cycle-false {
    background-color: #E93F66;
  }
  
  .status-cycle-true {
    background-color: #15CE9A;
  }
  
</style>
